import { useCallback, useEffect, useState } from 'react'
import { getMiroUserInfo } from '../util/info'
import TableKeeperService from 'src/service/TableKeeperService'

export enum AuthState {
  LOADING,
  AUTHENTICATED,
  UNAUTHENTICATED,
  AUTHORIZE,
  OUTSIDE_MIRO,
}

export const useAuth = () => {
  const [authState, setAuthState] = useState(AuthState.LOADING)

  const checkState = useCallback(async () => {
    const urlParams = new URLSearchParams(window.location.search)
    const boardId = urlParams.get('boardId')
    const userInfo = localStorage.getItem('userInfo')
    const workspaceHost = localStorage.getItem('workspaceHost')

    if (boardId) {
      setAuthState(AuthState.AUTHORIZE)
      return
    }

    const miroUserId = await getMiroUserInfo()

    if (!miroUserId) {
      setAuthState(AuthState.OUTSIDE_MIRO)
      return
    }

    if (!workspaceHost) {
      setAuthState(AuthState.UNAUTHENTICATED)
      return
    }

    if (userInfo) {
      setAuthState(AuthState.AUTHENTICATED)
      return
    }

    try {
      const fetchedUserInfo = await TableKeeperService.getUser(
        workspaceHost,
        miroUserId.id,
      )
      if (fetchedUserInfo) {
        localStorage.setItem('userInfo', JSON.stringify(fetchedUserInfo))
        setAuthState(AuthState.AUTHENTICATED)
      } else {
        setAuthState(AuthState.UNAUTHENTICATED)
      }
    } catch (error) {
      setAuthState(AuthState.UNAUTHENTICATED)
    }
  }, [])

  useEffect(() => {
    checkState()
  }, [checkState])

  const reset = () => {
    localStorage.clear()
    window.location.reload()
  }

  return { authState, reset }
}
